import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

let inMemoryBankBranches = [
  {
    brnId: 1,
    brnCode: "BRN001",
    brnBankReferance: 1,
    brnBank: 1,
    brnBankCode: "B001",
    brnName: "Commercial Bank Main Branch",
    brnDescription: "Head Office Branch Colombo",
    brnStatus: 2,
    brnActive: 1,
    createdBy: "System Admin",
    createdDate: "2026-01-15T09:00:00.000+00:00",
    lastModifiedBy: "System Admin",
    lastModifiedDate: "2026-01-15T09:00:00.000+00:00",
  },
  {
    brnId: 2,
    brnCode: "BRN002",
    brnBankReferance: 2,
    brnBank: 2,
    brnBankCode: "B002",
    brnName: "Bank of Ceylon City Branch",
    brnDescription: "Fort City Branch",
    brnStatus: 2,
    brnActive: 1,
    createdBy: "System Admin",
    createdDate: "2026-02-10T10:30:00.000+00:00",
    lastModifiedBy: "System Admin",
    lastModifiedDate: "2026-02-10T10:30:00.000+00:00",
  },
  {
    brnId: 3,
    brnCode: "BRN003",
    brnBankReferance: 3,
    brnBank: 3,
    brnBankCode: "B003",
    brnName: "Hatton National Bank Kandy Branch",
    brnDescription: "Central Province Regional Office",
    brnStatus: 2,
    brnActive: 1,
    createdBy: "System Admin",
    createdDate: "2026-03-01T14:15:00.000+00:00",
    lastModifiedBy: "System Admin",
    lastModifiedDate: "2026-03-01T14:15:00.000+00:00",
  },
];

const filterInMemory = (criteria) => {
  if (!criteria) return [...inMemoryBankBranches];

  return inMemoryBankBranches.filter((item) => {
    if (criteria.brnCode && (!item.brnCode || !item.brnCode.toLowerCase().includes(criteria.brnCode.toLowerCase().trim()))) {
      return false;
    }
    if (criteria.brnName && (!item.brnName || !item.brnName.toLowerCase().includes(criteria.brnName.toLowerCase().trim()))) {
      return false;
    }
    if (criteria.brnBankCode && (!item.brnBankCode || !item.brnBankCode.toLowerCase().includes(criteria.brnBankCode.toLowerCase().trim()))) {
      return false;
    }
    if (criteria.brnBankReferance && Number(item.brnBankReferance) !== Number(criteria.brnBankReferance)) {
      return false;
    }
    if (criteria.brnStatus != null && Number(item.brnStatus) !== Number(criteria.brnStatus)) {
      return false;
    }
    if (criteria.brnActive != null && Number(item.brnActive) !== Number(criteria.brnActive)) {
      return false;
    }
    return true;
  });
};

export const searchBankBranch = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/bankBranch/search`,
      data
    );
    if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
      return response.data;
    }
  } catch (e) {
    console.warn("Backend API endpoint failed or offline, using fallback state:", e);
  }
  return filterInMemory(data);
};

export const addBankBranchData = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/bankBranch`,
      data
    );
    const newRecord = {
      ...data,
      brnId: typeof response.data === "number" || typeof response.data === "string" ? response.data : (inMemoryBankBranches.length ? Math.max(...inMemoryBankBranches.map((b) => b.brnId)) + 1 : 1),
      createdDate: new Date().toISOString(),
      lastModifiedDate: new Date().toISOString(),
    };
    inMemoryBankBranches.unshift(newRecord);
    return response.data;
  } catch (e) {
    if (e.response) {
      throw e;
    }
    console.warn("Backend save endpoint failed or offline, using fallback state validation:", e);
    const duplicateName = inMemoryBankBranches.find(
      (b) =>
        b.brnName &&
        data.brnName &&
        b.brnName.trim().toLowerCase() === data.brnName.trim().toLowerCase() &&
        Number(b.brnBankReferance) === Number(data.brnBankReferance)
    );
    if (duplicateName) {
      const err = new Error("Bank Branch name already exists for the selected bank");
      err.response = { data: "Bank Branch name already exists for the selected bank" };
      throw err;
    }

    const duplicateCode = data.brnCode && data.brnCode.trim() !== "" && inMemoryBankBranches.find(
      (b) =>
        b.brnCode &&
        b.brnCode.trim().toLowerCase() === data.brnCode.trim().toLowerCase()
    );
    if (duplicateCode) {
      const err = new Error("Bank Branch code already exists");
      err.response = { data: "Bank Branch code already exists" };
      throw err;
    }

    const generatedId = inMemoryBankBranches.length ? Math.max(...inMemoryBankBranches.map((b) => b.brnId)) + 1 : 1;
    const generatedCode = `BRN${String(generatedId).padStart(10, "0")}`;
    const code = (data.brnCode && data.brnCode.trim() !== "") ? data.brnCode.trim() : generatedCode;
    const bankCode = (data.brnBankCode && data.brnBankCode.trim() !== "") ? data.brnBankCode.trim() : code;
    const newRecord = {
      ...data,
      brnId: generatedId,
      brnCode: code,
      brnBankCode: bankCode,
      createdDate: new Date().toISOString(),
      lastModifiedDate: new Date().toISOString(),
    };
    inMemoryBankBranches.unshift(newRecord);
    return newRecord.brnId;
  }
};

export const updateBankBranchData = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/bankBranch`,
      data
    );
    inMemoryBankBranches = inMemoryBankBranches.map((b) =>
      b.brnId === data.brnId ? { ...b, ...data, lastModifiedDate: new Date().toISOString() } : b
    );
    return response.data;
  } catch (e) {
    if (e.response) {
      throw e;
    }
    console.warn("Backend update endpoint failed or offline, using fallback state validation:", e);
    const duplicateName = inMemoryBankBranches.find(
      (b) =>
        b.brnId !== data.brnId &&
        b.brnName &&
        data.brnName &&
        b.brnName.trim().toLowerCase() === data.brnName.trim().toLowerCase() &&
        Number(b.brnBankReferance) === Number(data.brnBankReferance)
    );
    if (duplicateName) {
      const err = new Error("Bank Branch name already exists for the selected bank");
      err.response = { data: "Bank Branch name already exists for the selected bank" };
      throw err;
    }

    const duplicateCode = data.brnCode && data.brnCode.trim() !== "" && inMemoryBankBranches.find(
      (b) =>
        b.brnId !== data.brnId &&
        b.brnCode &&
        b.brnCode.trim().toLowerCase() === data.brnCode.trim().toLowerCase()
    );
    if (duplicateCode) {
      const err = new Error("Bank Branch code already exists");
      err.response = { data: "Bank Branch code already exists" };
      throw err;
    }

    inMemoryBankBranches = inMemoryBankBranches.map((b) =>
      b.brnId === data.brnId ? { ...b, ...data, lastModifiedDate: new Date().toISOString() } : b
    );
    return "Bank Branch updated successfully";
  }
};

export const getBankBranchDataById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/bankBranch/${id}`
    );
    if (response && response.data) {
      return response.data;
    }
  } catch (e) {
    console.warn("Backend getById failed or offline, using fallback state:", e);
  }
  return inMemoryBankBranches.find((b) => Number(b.brnId) === Number(id)) || null;
};
